import { EdrSensorModule } from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface EdrSensorGeneralFormValue {
  uiSettings: { edrSensor: EdrSensorModule };
}

// searchable keywords
export enum EdrSensorGeneralSearchableKeywords {
  EdrIncidents = 'EdrIncidents',
}
